var ScreenOptionsColumns = /** @class */ (function () {
    function ScreenOptionsColumns(columns) {
        this.columns = columns;
        columns.getColumnNames().forEach(function (column_name) {
            var column = columns.get(column_name);
            var input = ScreenOptionsColumns.getInputByName(column.name);
            if (input && input.parentElement.textContent.length === 0) {
                var label = document.createElement('span');
                label.innerHTML = column.label;
                input.parentElement.appendChild(label);
            }
        });
    }
    ScreenOptionsColumns.getInputByName = function (name) {
        var input = document.querySelector("input[name='" + name + "-hide']");
        return input ? input : false;
    };
    return ScreenOptionsColumns;
}());
export default ScreenOptionsColumns;
